// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"7b782473","55":"7b782473","243":"7b782473","347":"9089a5a6","613":"7b782473","674":"31d6cfe0","807":"7b782473"}[chunkId] + ".chunk.css";
};